import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import { __ } from '../../../../i18n/l10n';
import theme from '../../../../styled-components/dark';
import { ExternalArrow } from '../../assets/svg';

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  cursor: pointer;
  width: 100%;

  > * {
    transition: none 200ms ease-in-out;
    transition-property: transform, filter;
    filter: brightness(100%);
  }

  ${Target.__MOBILE__
    ? css`
        &:active {
          > * {
            transform: scale(0.95);
          }
        }
      `
    : css`
        &:active {
          > * {
            transform: scale(0.95);
          }
        }
        &:hover {
          > * {
            filter: brightness(120%);
          }
        }
      `}
`;

const Label = styled.div`
  position: relative;
  color: ${theme.MissionDetailsRulesButton.color};
  margin-right: 0.4em;
  width: fit-content;

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    bottom: -0.05em;
    left: 0;
    background: ${theme.MissionDetailsRulesButton.color};
  }
`;

const Icon = styled(ExternalArrow)`
  width: 1.3em;
`;

type MissionDetailsRulesButtonProps = {
  className?: string;
  onClick: () => void;
};

const MissionDetailsRulesButton = ({ className = '', onClick }: MissionDetailsRulesButtonProps) => (
  <Wrapper className={className} onClick={onClick}>
    <Label>{__('Rules')}</Label>
    <Icon />
  </Wrapper>
);

export default MissionDetailsRulesButton;
